import "core-js/modules/es7.string.pad-start";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { selectReportData } from '@/api/statistics';
import TopMessage from "../TopMessage.vue";
export default {
  data: function data() {
    return {
      tableData: [],
      loading: false,
      loading2: false
    };
  },
  components: {
    TopMessage: TopMessage
  },
  created: function created() {
    this.getExecute();
  },
  methods: {
    xiazai: function xiazai() {
      var _this = this;

      this.loading2 = true;
      var xhr = new XMLHttpRequest();
      var date = new Date();
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var dateday = year + '' + month;
      xhr.open("post", this.baseUrl + "api/v1/report/exportReportData", true); // get、post都可

      xhr.responseType = "blob"; // 转换流

      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对

      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

      xhr.onload = function () {
        if (xhr.status === 200) {
          var blob = xhr.response;
          var fileName = dateday + ".xlsx";

          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var a = document.createElement("a");
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }

        _this.loading2 = false;
      };

      xhr.onerror = function () {
        _this.loading2 = false;

        _this.$message.error("下载失败");
      };

      xhr.send(JSON.stringify({
        date: dateday
      }));
    },
    getExecute: function getExecute() {
      var _this2 = this;

      this.loading = true;
      var date = new Date();
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var dateday = year + '' + month;
      selectReportData({
        date: dateday
      }).then(function (res) {
        console.log(res);

        if (res.data.code == 200) {
          _this2.tableData = [res.data.data.data];
          _this2.loading = false;
        }
      }).catch(function (err) {});
    }
  }
};